import React, { useState } from 'react';
import { Mail, ArrowRight } from 'lucide-react';

const NewsletterSubscription = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');

    try {
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          'form-name': 'newsletter-subscription',
          email
        }).toString()
      });

      if (response.ok) {
        setStatus('success');
        setEmail('');
      } else {
        throw new Error('Subscription failed');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="bg-ta-green">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white mb-2">Stay Updated</h2>
          <p className="text-white/80 mb-6">
            Subscribe to our newsletter for travel tips, exclusive offers, and updates about Uganda.
          </p>

          <form 
            name="newsletter-subscription"
            method="POST"
            data-netlify="true"
            onSubmit={handleSubmit}
            className="max-w-md mx-auto"
          >
            <input type="hidden" name="form-name" value="newsletter-subscription" />
            
            <div className="flex">
              <div className="relative flex-1">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full pl-10 pr-3 py-2 rounded-l-md border-0 focus:ring-2 focus:ring-white"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-6 py-2 bg-white text-ta-green rounded-r-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-ta-green disabled:opacity-50 flex items-center"
              >
                {status === 'loading' ? (
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-ta-green"></div>
                ) : (
                  <>
                    Subscribe
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </>
                )}
              </button>
            </div>

            {status === 'success' && (
              <p className="mt-2 text-white text-sm">Thank you for subscribing!</p>
            )}
            {status === 'error' && (
              <p className="mt-2 text-red-200 text-sm">Something went wrong. Please try again.</p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewsletterSubscription;